import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
    return (
<>
  {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-light bg-light desktop d-block d-md-none">
        <a
          href="#"
          className="navbar-brand js-colorlib-nav-toggle colorlib-nav-toggle"
        >
          <i></i>
        </a>

        <a
          className=""
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <img src="img/logo.png" alt="Logo" />
        </a>
      </nav>

      {/* Aside Menu */}
      <aside id="colorlib-aside" role="complementary" className="js-fullheight">
        <nav id="colorlib-main-menu" role="navigation">
          <ul>
            <li className="colorlib-active">
              <a href="index.html">Home</a>
            </li>
            <li>
              <a href="#">Fertility</a>
            </li>
            <li>
              <a href="#">Cardiology</a>
            </li>
            <li>
              <a href="#">Spinal Surgery</a>
            </li>
            <li>
              <a href="#">Oncology</a>
            </li>
          </ul>
        </nav>

        {/* Footer */}
        <div className="colorlib-footer">
          <a href="index.html" style={{ backgroundImage: "url()" }}>
            <img style={{    width: "70%"}}  src="img/logo.png" alt="Footer Logo" />
          </a>

          <div className="mb-4 mt-4">
            <form action="#" className="colorlib-subscribe-form">
              <div className="form-group d-flex">
                <div className="icon">
                  <span className="icon-paper-plane"></span>
                </div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Email Address"
                />
              </div>
            </form>
          </div>

          <p className="pfooter">
            © ALL RIGHTS RESERVED BY{" "}
            <b>
              <a href="https://picano india.co.in/blog">Headmasters india</a>
            </b>{" "}
            2026. | Powered by{" "}
            <b>
              <a href="https://digics.in/">digics.in</a>
            </b>
          </p>
        </div>
      </aside>
</>


    );
}
function openNav() {
    document.getElementById("mySidenav").style.width = "50%";
  }
  
  function closeNav() {
    document.getElementById("mySidenav").style.width = "0";
  }
export default Header;
